export default "__VITE_ASSET__CATmO5xm__"